import InvoicePortalBilling from './InvoicePortalBilling';

export default InvoicePortalBilling;
